import { timeAPIAxios } from "core/axios";
export const getTime = async () => {
  try {
    const response = await timeAPIAxios.get("license/time");
    return response;
  } catch (error) {
    console.error(error);
  }
};
